/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, filter, take } from 'rxjs/operators';
import { SpinnerService } from '../../api/spinner.service';
import { AuthService } from 'src/app/auth/auth.service';
/*import { LoaderService } from "../shared/service/loader.service";*/

export const OAUTH_SCOPES = ['openid', 'profile', 'user.read'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private loaderService: SpinnerService, private authService: AuthService) {}

  private isTokenExpiringSoon(token: string, thresholdSeconds = 600): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      return payload.exp && (payload.exp - now) < thresholdSeconds;
    } catch {
      return true; // Treat as expiring if can't decode
    }
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('graph') !== -1) return next.handle(req);

    const token = this.authService.getIdToken();

    if (!token || this.isTokenExpiringSoon(token, 600)) {
      // Delegate token refresh to AuthService
      this.authService.refreshToken();
      return this.authService.refreshTokenStatus().pipe(
        filter((newToken) => !!newToken),
        take(1),
        switchMap((newToken) => {
          const authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${newToken}` },
          });
          return next.handle(authReq);
        })
      );
    } else {
      // Token is valid
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
      return next.handle(authReq);
    }
  }
}
